import { render, staticRenderFns } from "./StockScan.vue?vue&type=template&id=890c7aa0"
import script from "./StockScan.vue?vue&type=script&lang=ts"
export * from "./StockScan.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('890c7aa0')) {
      api.createRecord('890c7aa0', component.options)
    } else {
      api.reload('890c7aa0', component.options)
    }
    module.hot.accept("./StockScan.vue?vue&type=template&id=890c7aa0", function () {
      api.rerender('890c7aa0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/stock/StockScan.vue"
export default component.exports